import * as React from 'react';
import {styled, alpha} from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import Logo from "../logo.svg";
import {Button, Link as MaterialLink, Stack} from "@mui/material";
import {Squeeze as Hamburger} from 'hamburger-react'
import Divider from "@mui/material/Divider";
import { Link as RouterLink } from "react-router-dom";

const Search = styled('div')(({theme}) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.black, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.black, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
    },
}));

const SearchIconWrapper = styled('div')(({theme}) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({theme}) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1.5, 1, 1.5, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '50ch',
            '&:focus': {
                width: '55ch',
            },
        },
        [theme.breakpoints.down('md')]: {
            width: '28ch',
            '&:focus': {
                width: '35ch',
            },
        },
    },
}));

export default function AppHeader() {

    const [isOpen, setOpen] = React.useState(false)

    return (
        <Box sx={{flexGrow: 1}}>
            <AppBar position="fixed"  style={{boxShadow: 'none', backgroundColor: 'white', color: '#404040',
                paddingTop: 4}}>
                <Toolbar>
                    <Box sx={{
                        width: {xs: '150px', sm: '160px', md: '190px', lg: '218px'},
                        height: {xs: '80px', sm: '60px', md: '50px', lg: '71px'}
                    }}>
                        <img style={{width: '100%', height: '100%'}} src={Logo} alt='logo'/>
                    </Box>

                    <Search
                        sx={{display: {xs: 'none', sm: 'block', md: 'block', lg: 'block'}, margin: '0.5rem 0 0 2rem'}}>
                        <SearchIconWrapper>
                            <SearchIcon/>
                        </SearchIconWrapper>
                        <StyledInputBase
                            placeholder="Search…"
                            inputProps={{'aria-label': 'search'}}
                        />
                    </Search>
                    <Box sx={{flexGrow: 1}}/>
                    <Box sx={{display: {xs: 'none', sm: 'flex', md: 'flex'}}}>

                        <Stack direction='row' spacing={{xs: 1.5, md: 7, lg: 7}} alignItems='center'>
                            <MaterialLink href='https://hometutor.co.tz/' color="inherit" underline='none' sx={{
                                fontSize: {sm: 13, md: 18},
                                '&:hover': {
                                    borderBottom: '2px solid #de5103',
                                    textDecoration: 'none',
                                    paddingBottom: '8px',
                                    color: '#0D61FB'
                                }
                            }}> About us</MaterialLink>
                            <MaterialLink href='tel:+255 715 122 012' color="inherit" underline="none" sx={{
                                fontSize: {sm: 13, md: 18},
                                '&:hover': {
                                    borderBottom: '2px solid #de5103',
                                    textDecoration: 'none',
                                    paddingBottom: '8px',
                                    color: '#0D61FB'
                                }
                            }}> Become Tutor</MaterialLink>
                            <Box sx={{display: {xs: 'none', sm: 'flex', md: 'flex'}}}>
                                <RouterLink to='/auth' style={{ textDecoration: 'none' }}>
                                    <Button variant='contained' disableElevation sx={{
                                        borderRadius: 2,
                                        backgroundColor: "#de5103",
                                        width: {xs: 60, md: 90},
                                        height: {xs: 30, md: 40},
                                        fontSize: { sm: 12, md: 14},
                                        textTransform: 'lowercase',
                                        boxShadow: 'none',
                                        marginRight: {sm: 1, md: 5},
                                        '&:hover': {
                                            backgroundColor: '#de5103'
                                        }
                                    }}>
                                        login
                                    </Button>
                                </RouterLink>
                                <RouterLink to='auth/register' style={{ textDecoration: 'none' }}>
                                    <Button variant='outlined' sx={{
                                        borderRadius: 2,
                                        backgroundColor: "#fff",
                                        width: {xs: 60, md: 90},
                                        height: {xs: 30, md: 40},
                                        fontSize: { sm: 12, md: 14},
                                        color: '#de5103',
                                        textTransform: 'lowercase',
                                        borderColor: '#de5103',
                                        '&:hover': {
                                            borderColor: '#de5103'
                                        }
                                    }}>
                                        Register
                                    </Button>
                                </RouterLink>
                            </Box>
                        </Stack>

                    </Box>
                    <Box sx={{display: {xs: 'flex', sm: 'none'}, zIndex: 8, position: 'fixed', marginLeft: '80%'}}>
                        <Hamburger toggled={isOpen} toggle={setOpen} color='#de5103' rounded/>
                    </Box>
                </Toolbar>

            </AppBar>

            {/*###########################################  mobile nav bar  #######################3333*/}

            <Box sx={{
                backgroundColor: "white", position: "fixed", top: 0, right: 0, height: '100%', width: '100%',
                display: 'flex', justifyContent: 'center', transition: 'all .3s ease-in-out', zIndex: 1,
                transform: `${isOpen ? 'translateX(0)' : 'translateX(100%)'}`
            }}>
                <Box sx={{ marginTop: '30%'}}>

                    <Search >
                        <SearchIconWrapper>
                            <SearchIcon/>
                        </SearchIconWrapper>
                        <StyledInputBase
                            placeholder="Search…"
                            inputProps={{'aria-label': 'search'}}
                        />
                    </Search>

                    <Box sx={{ display: 'flex', flexDirection: 'column', marginTop: 2,
                        '& button': { color: '#88888C', fontSize: 14, textTransform: 'lowercase'},
                    '& button:hover' : {animation: 'pulse', animationDuration: '2s'}}} >
                       <Stack
                              divider={<Divider orientation="horizontal" flexItem />}
                              spacing={2}>
                           <Button variant='text' size='large' >
                               About us
                           </Button>
                           <Button variant='text' size='large' >Find tutor</Button>
                           <RouterLink to='/auth' style={{ textDecoration: 'none', marginLeft: 65 }}>
                           <Button variant='text' size='large' style={{ color: '#de5103'}}>register</Button>
                           </RouterLink>
                           <RouterLink to='/auth' style={{ textDecoration: 'none', marginLeft: 68 }}>
                           <Button variant='text' size='large' style={{ color: '#de5103'}}>login</Button>
                           </RouterLink>
                       </Stack>

                   </Box>

                </Box>
            </Box>


        </Box>
    );
}